import { FbCheck, FbwithStyles } from "@flexibees/core";
import { COLORS } from "../../constants/colors";

export const CustomCheckbox = FbwithStyles({
  root: {
    "&$checked": {
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
        color: COLORS.PRIMARY,
      },
      "& .MuiIconButton-label:after": {
        content: '""',
        left: 4,
        top: 4,
        height: 15,
        width: 15,
        position: "absolute",
        backgroundColor: COLORS.BLACK,
        zIndex: -1,
      },
    },
  },
  checked: {},
})(FbCheck);
